// extracted by mini-css-extract-plugin
export var buttonOwnMeal = "recipe-search-modal-module--button-own-meal--+Jt2w";
export var error = "recipe-search-modal-module--error--d8nZh";
export var filterBox = "recipe-search-modal-module--filter-box--tOc25";
export var filtersWrapper = "recipe-search-modal-module--filters-wrapper--SkrgI";
export var list = "recipe-search-modal-module--list--yNXGP";
export var modal = "recipe-search-modal-module--modal--+Qaxh";
export var noContent = "recipe-search-modal-module--no-content--Dig8x";
export var recipesLoader = "recipe-search-modal-module--recipes-loader--FwxB8";
export var separator = "recipe-search-modal-module--separator--HQ5JP";